type ConfirmModalProps = {
    isOpen: boolean;
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    loading?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
  };
  
  const ConfirmModal = ({
    isOpen,
    title = "Confirm Action",
    message,
    confirmText = "Confirm",
    cancelText = "Cancel",
    loading = false,
    onConfirm,
    onCancel,
  }: ConfirmModalProps) => {
    if (!isOpen) return null;
  
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
          <h2 className="text-lg font-semibold mb-3">{title}</h2>
  
          <p className="text-gray-600 mb-6">{message}</p>
  
          <div className="flex justify-end gap-3">
            <button
              onClick={onCancel}
              disabled={loading}
              className="px-4 py-2 rounded border text-gray-700 disabled:opacity-50"
            >
              {cancelText}
            </button>
  
            <button
              onClick={onConfirm}
              disabled={loading}
              className="px-4 py-2 rounded bg-red-600 text-white disabled:opacity-50"
            >
              {loading ? "Processing..." : confirmText}
            </button>
          </div>
        </div>
      </div>
    );
  };
  
  export default ConfirmModal;
  